import { useEffect, useRef } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import axios from 'axios';
import { Loader2 } from 'lucide-react';
import { useLang } from '../i18n';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const AuthCallback = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { t } = useLang();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;
    const sessionId = new URLSearchParams(location.hash.replace(/^#/, '')).get('session_id');
    if (!sessionId) {
      navigate('/catalogo', { replace: true });
      return;
    }
    axios.post(`${API}/auth/session`, { session_id: sessionId }, { withCredentials: true })
      .then((r) => navigate('/catalogo', { state: { user: r.data }, replace: true }))
      .catch(() => navigate('/catalogo', { replace: true }));
  }, []);

  return (
    <div className="min-h-screen flex flex-col items-center justify-center gap-4" data-testid="auth-callback">
      <Loader2 className="w-8 h-8 animate-spin text-secondary" />
      <p className="text-sm text-foreground/50 font-display uppercase tracking-widest">{t('authwall.checking')}</p>
    </div>
  );
};

export default AuthCallback;
